import notifyServerOfSignup from "./notifyServerOfSignup";
import findFormInvalidity from "./findFormInvalidity";
export default function AuthFormActionButton({
  isProcessing,
  scene,
  setScene,
  setResponses,
  dispatch,
  A,
  form,
  route,
  forms,
}){
  return (

    <button 
          buttonDisabled={Boolean(isProcessing)+""}
          disabled={isProcessing}
          form={scene}
          formComponentType={"submit"}
          style={{
          }}

          onClick={ () => {

            let formInvalidity = findFormInvalidity(form,scene,forms);
            if( formInvalidity ){
              setResponses({
                client:formInvalidity
              });
            }else{

              setResponses({});

              let actionMap = {
                signin:'tryLogin',
                signup:'trySignup',
                forgot:'requestPasswordRecoveryCode',
                changePassword:'changePassword',
              }

              let nextSceneMap = {
                forgot:'changePassword',
              }

              let actionName = actionMap[scene];

              //setIsProcessing(true);


              if( true || process.env.NODE_ENV === 'production'){
                if( scene === 'signup' || scene === 'forgot' ){
                  notifyServerOfSignup(form,scene,route,setResponses)
                }
              }


              dispatch(A[actionName]({ ...form }))

              let nextScene = nextSceneMap[ scene ];
              if( nextScene ){
                setScene(nextScene);
              }
            }


          
        }}
          class="form-control btn btn-primary bold">{forms[scene].action}</button>
  )
}
